import BotDialogType from '../../core/type/dialog/BotDialogType';
import TextInputType from '../../core/type/input/TextInputType';
import UserDialogType from '../../core/type/dialog/UserDialogType';
import { sendBotResponse } from './util';
import Interceptor from '../../core/type/operation/Interceptor';
import SelectorInputType from '../../core/type/input/SelectorInputType';
import Switch from '../../core/type/operation/Switch';
import Case from '../../core/type/operation/Case';

const funnyPlaceholders = [
  {
    companyCategory: 'Consultor de Marketing',
  },
  {
    companyCategory: 'Restaurante',
  },
  {
    companyCategory: 'Clinica médica',
  },
  {
    companyCategory: 'Fábrica de Software',
  },
];

const num = Math.floor(Math.random() * funnyPlaceholders.length);

export default [
  new BotDialogType({
    message: `Olá, tudo bem? O nosso objetivo aqui é te ajudar a encontrar o parceiro ideal para a sua necessidade. 
    Para isso, preciso te fazer umas perguntas.`,
    checkpoint: true,
  }),
  new BotDialogType({
    message: 'Primeiramente, como posso te chamar?',
    checkpoint: true,
  }),
  new TextInputType({
    placeholder: 'Digite seu nome completo',
    key: 'name',
  }),
  new Interceptor(async (data) => new Promise((resolve) => {
    const newData = data;
    const firstname = data.name.split(' ')[0];
    newData.first_name = firstname.charAt(0).toUpperCase() + firstname.slice(1);
    resolve({ ...newData });
  })),
  new UserDialogType({
    message: 'Meu nome é #{name}.',
  }),
  new BotDialogType({
    message: 'Legal #{first_name}. E qual é o nome da sua empresa/negócio?',
    checkpoint: true,
  }),
  new TextInputType({
    placeholder: 'Ex: Capsule Corp',
    key: 'company_name',
  }),
  new UserDialogType({
    message: '#{company_name}',
  }),

  new BotDialogType({
    message: 'Certo, agora selecione qual o seu segmento de atuação.',
    checkpoint: true,
  }),

  new SelectorInputType({
    key: 'company_segment',
    type: 'buttonSelector',
    options: 'segment_options',
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, company_segment: data.company_segment },
      company_segment: data.company_segment.value,
    });
  })),

  new UserDialogType({
    message: '#{company_segment}',
  }),

  new Switch({
    ref: 'company_segment',
    cases: [
      new Case({
        express: '\'$v\' === \'Outros\'',
        components: [
          new BotDialogType({
            message: 'Pode nos informar qual outro segmento que não estava listado?',
            checkpoint: true,
          }),

          new TextInputType({
            key: 'other_company_segment',
          }),

          new UserDialogType({
            message: '#{other_company_segment}',
          }),

        ],
      }),
    ],
  }),

  new BotDialogType({
    message: `
    Certo, ainda não sei em qual categoria sua empresa se enquadra. Poderia me informar?`,
    tooltip: 'Exemplos: Consultoria Esportiva, Startup de Tecnologia, Restaurante, Clínica de Estética, Indústria de alimentos, Construtora, etc...',
  }),

  new TextInputType({
    placeholder: `Ex.: ${funnyPlaceholders[num].companyCategory}`,
    key: 'company_category',
  }),

  new UserDialogType({
    message: 'Somos um(a) #{company_category}',
  }),

  new BotDialogType({
    message: 'Entendi. E quantos funcionários vocês tem no total?',
    checkpoint: true,
  }),
  new TextInputType({
    placeholder: 'Digite um número.',
    mask: '999999',
    key: 'company_employees',
    suggestionsId: 'number_all_employee_suggestions',
    numberMode: true,
  }),

  new UserDialogType({
    message: 'Temos <b>#{company_employees}</b> funcionários.',
  }),

  new BotDialogType({
    message: 'Qual o seu cargo aí na #{company_name}?',
    checkpoint: true,
  }),

  new SelectorInputType({
    key: 'company_role',
    type: 'radio',
    column: 'half',
    options: 'option_roles',
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, company_role: data.company_role },
      company_role: data.company_role.text,
    });
  })),

  new UserDialogType({
    message: '#{company_role}',
  }),

  new BotDialogType({
    message: 'Para que possamos continuar, eu preciso saber seu e-mail.',
  }),

  new TextInputType({
    placeholder: 'Digite seu e-mail',
    key: 'email',
    validation: 'email',
  }),

  new UserDialogType({
    message: 'Meu email é #{email}',
  }),
  new BotDialogType({
    message: 'E agora, seu celular.',
  }),
  new TextInputType({
    placeholder: 'Informa seu celular',
    validation: 'phone',
    key: 'phone',
    defaultData: 'phone',
    mask: '(99) 99999-9999',
  }),

  new UserDialogType({
    message: '#{phone}.',
  }),

  new BotDialogType({
    message: 'Informe a seguir links importantes como websites e/ou redes sociais relacionados ao seu negócio/necessidade',
    checkpoint: true,
  }),

  new TextInputType({
    placeholder: 'redes sociais, página de vendas, websites, etc...',
    key: 'links',
    textareaMode: true,
    optional: true,
  }),

  new UserDialogType({
    message: '#{links}.',
  }),

  sendBotResponse(),
];
